"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DISABLED = exports.REVERSE = exports.MONTH = exports.YEAR = void 0;
// according moment.js
var YEAR = 'year';
exports.YEAR = YEAR;
var MONTH = 'month'; // sorting

exports.MONTH = MONTH;
var REVERSE = 'reverse';
exports.REVERSE = REVERSE;
var DISABLED = 'disabled';
exports.DISABLED = DISABLED;